import jwt from "jwt-decode";
import {RequestController as $request} from "@/plugins/fetch";
import {parseResponseJSON} from "@/utils";

// export the store module
export default {
    state: {
        token: "",
        lastRequest: null
    },
    actions: {
        /*
            The $request controller supports both timing-out and aborting reqs,
            with timeouts automatically cancelling the fetch, and aborts being
            programmatic triggers. This is handy if you want to "forget" about
            an in-progress request, as in the following example.
        */
        getToken ({commit}, request) {

            if (!request) {
                return Promise.reject("no request provided to getToken");
            }

            commit("setActiveReq", request);

            return request
                .then(parseResponseJSON)
                .then(token => commit("setToken", token));
        }
    },
    mutations: {

        setActiveReq (state, request) {
            if (state.lastRequest) {
                // the aborted request is tossed into Promise.reject()
                $request.abort(state.lastRequest);
            }
            state.lastRequest = request;
        },

        setToken (state, token) {
            try {
                const {role, id} = jwt(token);
                state.role = role;
                state.id = id;
                state.token = token;
            } catch (err) {
                Promise.reject(err);
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js